// A winning position let slip with the clock nearly out: the reader's first
// move, anywhere in the game, that took a winning position under the held
// line (the rules' `winningPawns` and `heldPawns`, as `ScannedGame.threw`)
// with under `TIME_SLIP_SECONDS` left on their clock after it, whatever the
// result. Games whose PGN carries no clock times get no such fact.
import { type FactExtractor, type ScannedGame } from '../extractor.ts';
import { TIME_SLIP_SECONDS, type GameFacts } from '@chess/api-model';

export const timeSlip: FactExtractor = {
  id: 'time-slip',
  extract(game: ScannedGame, facts: GameFacts): void {
    for (let ply = 1; ply <= game.moves.length; ply++) {
      if (!game.isReaders(ply)) continue;
      const seconds = game.clockAfter(ply);
      if (seconds === undefined || seconds >= TIME_SLIP_SECONDS || !game.threw(ply)) continue;
      facts.timeSlip = { ply, san: game.moves[ply - 1]?.san ?? '', seconds };
      return;
    }
  },
};
